import { preload } from "../include/module";
import { anchorLink } from "../include/module";
import { toggleHeader } from "../include/module";
import { pageTop } from "../include/module";





(() => {

  preload();
  anchorLink();
  toggleHeader();
  pageTop();

})();



// WEBPACK FOOTER //
// ./src/en_bang-dream_v0/assets/js/common/script.js